var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIconSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7018 14.2753C10.7018 11.9013 12.6358 9.97736 15.0208 9.97736C17.4057 9.97736 19.3397 11.9013 19.3397 14.2753C19.3397 16.6494 17.4057 18.5733 15.0208 18.5733C12.6358 18.5733 10.7018 16.6494 10.7018 14.2753Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4C8.92487 4 4 8.92487 4 15C4 21.0751 8.92487 26 15 26C21.0751 26 26 21.0751 26 15C26 8.92487 21.0751 4 15 4ZM6.2 15C6.2 10.1399 10.1399 6.2 15 6.2C19.8601 6.2 23.8 10.1399 23.8 15C23.8 17.5207 22.7401 19.7939 21.0417 21.3983C20.4975 20.0644 19.1824 19.1241 17.6471 19.1241H12.3944C10.8482 19.1241 9.52549 20.0777 8.98837 21.4266C7.27239 19.8207 6.2 17.5356 6.2 15Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconSelected);
export default __webpack_public_path__ + "static/media/profile-icon-selected.dcf5fdef48ff79b34a911b57c8ffb64b.svg";
export { ForwardRef as ReactComponent };